var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "twitter 1",
    clipPath: "url(#clip0_137_56)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M14.8507 3.35593C14.8588 3.50218 14.8588 3.64879 14.8507 3.79504C14.8482 5.52692 14.3803 7.22629 13.4957 8.71523C12.6111 10.2042 11.3425 11.4279 9.82269 12.2584C8.3029 13.0888 6.58779 13.4954 4.85695 13.4355C3.1261 13.3757 1.44319 12.8516 -0.015625 11.9182C0.255969 11.9338 0.528218 11.9338 0.799812 11.9182C2.33115 11.9275 3.81964 11.4129 5.01822 10.4598C4.31608 10.4413 3.63704 10.2049 3.07513 9.78352C2.51322 9.36209 2.09624 8.77641 1.88186 8.10754C2.09587 8.12377 2.31081 8.12377 2.52482 8.10754C2.82693 8.10433 3.12738 8.06217 3.4187 7.98208C2.64929 7.82956 1.95663 7.41474 1.459 6.80843C0.961365 6.20212 0.689583 5.4419 0.690028 4.65752C1.17202 4.92256 1.70867 5.07282 2.25821 5.09661C1.53334 4.61789 1.0201 3.87899 0.824554 3.0326C0.62901 2.18622 0.76614 1.29706 1.20755 0.548891C2.05738 1.60082 3.11958 2.4616 4.32477 3.075C5.52997 3.68841 6.85103 4.04065 8.20163 4.10867C8.15145 3.85027 8.12522 3.5878 8.12324 3.32458C8.12097 2.64355 8.32404 1.97766 8.70595 1.41379C9.08786 0.849919 9.63083 0.414257 10.2641 0.163665C10.8973 -0.0869256 11.5915 -0.140807 12.2558 0.00903914C12.9201 0.158885 13.5239 0.505489 13.9882 1.00365C14.748 0.86473 15.476 0.588407 16.1366 0.188216C15.883 0.970478 15.3535 1.63377 14.6469 2.05436C15.321 1.97298 15.9807 1.79883 16.6071 1.53685C16.1323 2.24108 15.5378 2.85671 14.8507 3.35593Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_137_56"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16.56,
    height: 13.4393,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter1);
export default __webpack_public_path__ + "static/media/twitter 1.b7244ec1f5a3ecf24c0c912a7a242250.svg";
export { ForwardRef as ReactComponent };